<template>  
  <div class="create-dilution">
    <div class="row">
      <div class="col-sm-12">
        <mu-text-field v-model="drugName" label="Spädningsläkemedelsnamn" labelFloat/>
      </div>
      <div class="col-sm-12">
        <mu-raised-button class="demo-raised-button" label="Lägg till" icon="add" primary @click="createDilution"/>
        <mu-raised-button class="demo-raised-button" label="Avbryt" icon="cancel" @click="closeDialog"/>
      </div>
    </div>
  </div>
</template>

<script>
import { createDilution } from '../store/actions'

export default {
  name: 'CreateDilution',
  data () {
    return {
      drugName: ''
    }
  },
  mounted () {
  },
  computed: {
  },
  methods: {
    createDilution () {
      createDilution(this.$store, this.drugName)
    },
    closeDialog () {
      this.$emit('close')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.create-dilution {
   
}
</style>
